import { ColoredAlert } from '@bpinternal/ui-kit-next'
import { BannerPortal } from '~/components'

export const BillingReadonlyCallout = () => {
  return (
    <BannerPortal>
      <ColoredAlert color="blue" className="m-2">
        <div className="flex justify-center">
          Billing cannot be modified. Please contact your Botpress representative to make changes.
        </div>
      </ColoredAlert>
    </BannerPortal>
  )
}
